import { NgModule }             from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModuleComponent }    from './module.component';

const SECURITY_ROUTES: Routes = [
  { path: 'security/module', component: ModuleComponent }
];

export const ROUTABLE_COMPONENTS = [
];

@NgModule({
  imports: [
    RouterModule.forChild(SECURITY_ROUTES)
  ],
  exports: [
    RouterModule
  ],
  providers: []
})
export class ModuleRoutingModule {}